'use client';

import { defaultRangeExtractor, type Range } from '@tanstack/react-virtual';
import { useCallback, useState } from 'react';

// A virtualized row with an open popover anchored to it (its notes) stays mounted while a scroll or a re-sort would take
// it out of the rendered window, so the popover keeps its trigger: Floating UI follows the row as it moves and hides the
// popover while the row is out of view. Rows report their popover with onAnchorChange(key, open); the list passes
// rangeExtractor to its virtualizer. `indexOf` finds a row's index by its key (-1 when it left the list).
export function useAnchoredRow(indexOf: (key: string) => number) {
  const [key, setKey] = useState<string | null>(null);
  const onAnchorChange = useCallback((k: string, open: boolean) => setKey(cur => (open ? k : cur === k ? null : cur)), []);
  const index = key === null ? -1 : indexOf(key);
  const rangeExtractor = useCallback((range: Range) => {
    const items = defaultRangeExtractor(range);
    return index < 0 || items.includes(index) ? items : [...items, index].sort((a, b) => a - b);
  }, [index]);
  return { rangeExtractor, onAnchorChange };
}
